import { render, staticRenderFns } from "./unconfirmed.page.vue?vue&type=template&id=6bdae558&"
import script from "./unconfirmed.page.vue?vue&type=script&lang=js&"
export * from "./unconfirmed.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports